import { Component, OnInit } from '@angular/core';
import { WebsocketService } from '../../../services/websocket/websocket.service';
import { SnotifyService } from 'ng-snotify';
import { PendenciaService } from '../../../services/pendencia/pendencia.service';
import { EmpresaService } from '../../../services/empresa/empresa.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';



@Component({
    selector: 'app-monitor-list-pendencias',
    templateUrl: './monitor-pendencias.component.html',
    styleUrls: ['./monitor-pendencias.component.scss'],
})
export class MonitorPendenciasComponent implements OnInit {

    public loading = false;

    public filter: FormGroup;

    public dataEstatistica = null;

    constructor(
        private websocket: WebsocketService,
        private _notify: SnotifyService,
        private pendenciaService: PendenciaService,
        private empresaService: EmpresaService,
        private fb: FormBuilder
    ) {
    }

    public listaArquivos: Array<any> = [];

    public listaGrupos: Array<any> = [];

    public lastResponse = null;

    public currentPage = 1;

    public perPage: string|number = 20;

    public empresas: Array<any> = [];

    public loadChangeStatus = {};

    public dropdownSettingsEmpresas = {
        singleSelection: false,
        idField: 'id_empresa',
        textField: 'descricao',
        itemsShowLimit: 5,
        selectAllText: 'Marcar todas',
        unSelectAllText: 'Desmarcar todas',
        allowSearchFilter: true
    };

    public dropdownSettingsGrupos = {
        singleSelection: false,
        idField: 'id',
        textField: 'descricao',
        itemsShowLimit: 10,
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        allowSearchFilter: true
    };

    public dropdownSettingsPrioridade = {
        singleSelection: true,
        idField: 'id',
        textField: 'descricao',
        itemsShowLimit: 10,
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        allowSearchFilter: false
    };


    ngOnInit() {
        this._initFilters();
        this._listarEmpresas();
        this._loadArquivos();
        this._loadEstatistica()
    }

    private _loadArquivos(page: string|number = 1): void {
        this.loading = true;
        this.pendenciaService.listar(this.getFilters(), page, this.perPage).subscribe(
            ({data}) => {
                this.loading = false;
                this.lastResponse = data.data;
                this.listaArquivos = this.listaArquivos.concat(data.data.data);
            },
            error => {
                this._notify.error('Ocorreu um erro ao listar dados');
                this.loading = false;
            }
        );
    }

    public loadMore(): void {
        this.currentPage++;
        this._loadArquivos(this.currentPage);
    }

    public loadPerPage($event) {
        this.perPage = $event.target.value;
        this.reset(false);
        this._loadArquivos();
    }

    public reset(reload: boolean): void {
        this.listaArquivos = [];
        this.currentPage = 1;

        if (reload) {
            Object.keys(this.filter.controls).forEach(key => {
                this.filter.controls[key].setValue('');
            });

            this._loadArquivos();
        }
    }

    private _listarEmpresas(): void  {
        this.empresaService.listar(null, '', 'todos')
            .subscribe(
                ({data}) => {
                    this.empresas = data.empresas.map(empresa => {
                        return {
                            id_empresa: empresa.id_empresa,
                            descricao: `${empresa.apelido} - ${empresa.cpf_cnpj}`
                        };
                    });
                },
                error => {
                    this._notify.warning('Ocorreu um erro ao carregar empresas');
                }
            );

        this.empresaService.buscarEmpresasVinculadasGrupo().subscribe(({data}) => {
            const grupos = [];
            for (let i = 0; i < data.length; i++) {
                grupos.push({descricao: data[i].nome_grupo, id: data[i].id});
            }
            this.listaGrupos = grupos;
        });
    }

    private _initFilters() {

        this.filter = this.fb.group({
            empresa_id: new FormControl('', []),
            grupo_id: new FormControl('', []),
        });
    }

    public toFilter() {
        this.reset(false);
        this._loadArquivos();
    }

    public getFilters() {
        const filter = {};

        Object.keys(this.filter.controls).forEach((_filter) => {
            filter[_filter] = this.filter.controls[_filter].value;
        });


        if (filter['empresa_id']) {
            filter['empresa_id'] = filter['empresa_id'].map(empresa => {
                return empresa.id_empresa;
            });
        }

        if (filter['grupo_id']) {
            filter['grupo_id'] = filter['grupo_id'].map(grupo => {
                return grupo.id;
            });
        }
        return filter;
    }

    private _loadEstatistica(): void {
        this.pendenciaService.listarEstatisticaGeral().subscribe(
            ({data}) => {
                this.dataEstatistica = {
                    labels: [
                        '+5 dias',
                        '+3 dias',
                        '-3 dias'
                    ],
                    datasets: [{
                        label: 'Estatistica Geral de Documentos Pendentes',
                        data: [data['+5'], data['+3'], data['-3']],
                        backgroundColor: [
                            '#fb4e4e',
                            '#f3ad2e',
                            '#abf2fd'
                        ],
                        hoverOffset: 4
                    }]
                }
            },
            error => {
                console.error(error);
            }
        );
    }
}
